export class SubMenu{
  displayName!: string
  iconName!: string
  route!:string
  orden!: number
}

export class Menu{
  displayName!: string
  iconName!: string
  submenues: SubMenu[] = []
  route!:string
  orden!: number
}
